import { Injectable } from '@angular/core';
import { RequestHelperProvider } from './request-helper';
import { Settings } from './../_models/settings/settings.model';
import { StorageServiceProvider } from './services';
import { StorageKeys } from '../_constants';

@Injectable({
  providedIn: 'root' 
})
export class LocationServiceProvider {

    constructor(private helper: RequestHelperProvider, private storage: StorageServiceProvider) {
        console.log('Hello LocationServiceProvider Provider');
    }

    public syncLocations(callback) {
        let tenantID = this.storage.get(StorageKeys.DataSet).TenantID;
        this.helper.PostServerCommand(`/culturahub/RESTCommandWebService/ExecuteServerCommand/LocationProcessor/GetLocationsByTenantID?TenantID=${tenantID}`, null, (res) => {
            let returnarray: Settings[] = [];
            for (var i = 0; i < res.length; i++) {
                let resultvalue = new Settings();
                resultvalue.code = res[i].Code;
                resultvalue.description = res[i].Description;
                returnarray.push(resultvalue);
            }
            callback(returnarray);
        },
            (error) => {
                callback(error);
            }
        )
    }
}
